export default __webpack_public_path__ + "static/media/juliette_has_a_gun_lowdef.6bfacebe.png";